import React from "react";
import { Helmet } from "react-helmet";
import SEOHead from "../components/SEOHead";
import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Fab from "@material-ui/core/Fab";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import SendIcon from "@material-ui/icons/Send";
import DoneIcon from "@material-ui/icons/Done";
import DeleteIcon from "@material-ui/icons/Delete";
import DeleteSharpIcon from "@material-ui/icons/DeleteSharp";

import localizationManager from "./localizationManager";

import {
  withStyles,
  withTheme,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

const theme = createMuiTheme({
  overrides: {
    MuiTableCell: {
      root: {
        padding: "16px 10px 8px 10px",
      },
    },
  },
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#2196f3",
    },
    secondary: {
      main: "#E44A4B",
    },
  },
});

const styles = (theme) => ({
  root: {
    marginLeft: "5%",
    marginRight: "5%",
    marginTop: theme.spacing.unit * 12,
    [theme.breakpoints.up(960)]: {
      width: "60%",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: theme.spacing.unit * 12,
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
    overflowX: "auto",
  },
  formArea: {
    marginBottom: theme.spacing.unit * 1,
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  textFields: {
    padding: 0,
  },
});

class Inquiry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: "",
      website: "",
      name: "",
      email: "",
      tel: "",
      jobTitle: "",
      country: "",
      address: "",
      how: "",
      inquiry: "",
      message: "",
      location: "",
      isSubmitting: false,
      hasSent: false,
      hasError: false,
      isDialogOpen: false,
    };
  }

  componentDidMount() {
    //NOTE: using https://ipinfo.io/account free plan to get ip & location info
    fetch("https://ipinfo.io?token=20bedc24fd9975")
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        let locationInfo =
          result.ip + " " + result.city + ", " + result.country;
        // console.log("locationInfo:" + locationInfo);
        this.setState({
          location: locationInfo,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    // console.log("Json:" + JSON.stringify(this.state));
  };

  handleSubmit = (event) => {
    this.setState({ isSubmitting: true });
    event.preventDefault();
    const url =
      "https://script.google.com/a/dc-ac.com/macros/s/AKfycbzU7_yEANjzaj5gSTltbAtWoDwETxTmQj1JW3654A/exec";
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        company: this.state.company,
        website: this.state.website,
        name: this.state.name,
        email: this.state.email,
        tel: this.state.tel,
        jobTitle: this.state.jobTitle,
        country: this.state.country,
        address: this.state.address,
        how: this.state.how,
        inquiry: JSON.stringify(this.props.cart),
        message: this.state.message,
        location: this.state.location,
      }),
      headers: {
        //NOTE: this has to be "text/plain", otherwise "blocked by CORS policy" will show up
        "Content-Type": "text/plain",
      },
    })
      .then((res) => console.log("Result:", res))
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ isSubmitting: false, hasSent: true, hasError: true });
      })
      .then((response) => {
        // console.log("Success:", response);
        this.setState({ isSubmitting: false, hasSent: true, hasError: false });
      });
  };

  handleDialogOpen = () => {
    this.setState({ isDialogOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ isDialogOpen: false });
  };

  handleDialogConfirm = () => {
    this.setState({ isDialogOpen: false });
    localStorage.removeItem("inquiryCart");
    window.location.reload();
  };

  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <React.Fragment>
          <CssBaseline />
          <div className={classes.root}>
            <SEOHead
              title={localizationManager.getLocalStringPlain("@@seo_inquiry_title")}
              description={localizationManager.getLocalStringPlain("@@seo_inquiry_description")}
              location={this.props.location}
              lang={localizationManager.currentLang}
            />
            <Helmet>
              <meta property="og:title" content={localizationManager.getLocalStringPlain("@@seo_inquiry_title")} />
              <meta property="og:description" content={localizationManager.getLocalStringPlain("@@seo_inquiry_description")} />
              <meta property="og:type" content="website" />
              <meta
                property="og:image"
                content="https://www.dc-ac.com/images/LinkChamp-OG-Image.png"
              />
            </Helmet>
            <Typography
              component="h1"
              variant="h5"
              gutterBottom
              color="textSecondary"
              align="center"
            >
              {localizationManager.getLocalString("@@inquiry_title")}
            </Typography>
            {this.state.isSubmitting || this.state.hasSent ? (
              <>
                <Paper className={classes.paper}>
                  <Grid
                    container
                    spacing={16}
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"
                        component="h2"
                        gutterBottom
                      >
                        {this.state.isSubmitting
                          ? localizationManager.getLocalString(
                              "@@submitting_inquiry"
                            )
                          : this.state.hasError
                          ? localizationManager.getLocalString(
                              "@@submission_failed"
                            )
                          : localizationManager.getLocalString(
                              "@@submission_success"
                            )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      {this.state.isSubmitting ? (
                        <CircularProgress color="secondary" />
                      ) : (
                        <Fab
                          color="secondary"
                          aria-label="Done"
                          onClick={() => {
                            if (!this.state.hasError) {
                              localStorage.removeItem("inquiryCart");
                            }
                            window.location.reload();
                          }}
                        >
                          <DoneIcon />
                        </Fab>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </>
            ) : (
              <>
                <form onSubmit={this.handleSubmit}>
                  <Paper className={classes.paper}>
                    <div>
                      <Typography
                        variant="subtitle1"
                        component="h3"
                        gutterBottom
                      >
                        <b>
                          {localizationManager.getLocalString("@@inquiry_cart")}
                        </b>
                      </Typography>
                    </div>
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="center"
                      className={classes.formArea}
                    >
                      <Grid item xs={12}>
                        {Object.keys(this.props.cart).length > 0 ? (
                          <Table className={classes.table}>
                            <TableHead>
                              <TableRow>
                                <TableCell align="center">
                                  {localizationManager.getLocalString(
                                    "@@product"
                                  )}
                                </TableCell>
                                <TableCell>
                                  {localizationManager.getLocalString(
                                    "@@product_name"
                                  )}
                                </TableCell>
                                <TableCell align="left">
                                  {localizationManager.getLocalString(
                                    "@@ac_voltage"
                                  )}
                                </TableCell>
                                <TableCell align="left">
                                  {localizationManager.getLocalString("@@moq")}
                                </TableCell>
                                <TableCell align="center"> </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Object.keys(this.props.cart).map(
                                (key, index) => (
                                  <TableRow key={index}>
                                    <TableCell align="center">
                                      <Link
                                        component={RouterLink}
                                        to={this.props.cart[key].url}
                                      >
                                        <img
                                          src={this.props.cart[key].img}
                                          alt={key}
                                          loading="lazy"
                                          width={64}
                                        />
                                      </Link>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      <Link
                                        component={RouterLink}
                                        to={this.props.cart[key].url}
                                      >
                                        <Typography
                                          variant="button"
                                          gutterBottom
                                        >
                                          {key}
                                        </Typography>
                                      </Link>
                                    </TableCell>
                                    <TableCell align="left">
                                      <FormControl>
                                        <Select
                                          value={this.props.cart[key].spec}
                                          onChange={(event) => {
                                            this.props.cartCallback({
                                              name: key,
                                              moq: this.props.cart[key].moq,
                                              img: this.props.cart[key].img,
                                              url: this.props.cart[key].url,
                                              spec: event.target.value,
                                              isNewAdd: false,
                                            });
                                          }}
                                        >
                                          <MenuItem value={0}>N/A</MenuItem>
                                          <MenuItem value={230}>
                                            220~240V
                                          </MenuItem>
                                          <MenuItem value={120}>
                                            110~127V
                                          </MenuItem>
                                          <MenuItem value={100}>100V</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell align="left">
                                      <FormControl>
                                        <Select
                                          value={this.props.cart[key].moq}
                                          onChange={(event) => {
                                            this.props.cartCallback({
                                              name: key,
                                              moq: event.target.value,
                                              img: this.props.cart[key].img,
                                              url: this.props.cart[key].url,
                                              spec: this.props.cart[key].spec,
                                              isNewAdd: false,
                                            });
                                          }}
                                        >
                                          <MenuItem value={10}>10</MenuItem>
                                          <MenuItem value={50}>50</MenuItem>
                                          <MenuItem value={100}>100</MenuItem>
                                          <MenuItem value={200}>200</MenuItem>
                                          <MenuItem value={500}>500</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell align="right">
                                      <IconButton
                                        aria-label="Delete"
                                        onClick={() => {
                                          this.props.cartCallback({
                                            name: key,
                                            moq: 0,
                                          });
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                        ) : (
                          <TextField
                            disabled
                            error
                            label={localizationManager.getLocalString(
                              "@@inquiry_cart_empty"
                            )}
                            fullWidth
                            multiline
                            rows="3"
                            className={classes.textField}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Paper>
                  <Paper className={classes.paper}>
                    <div>
                      <Typography
                        variant="subtitle1"
                        component="h2"
                        gutterBottom
                        inline
                      >
                        <b>
                          {localizationManager.getLocalString("@@contact_info")}
                        </b>
                      </Typography>
                      {/* <Typography
                        variant="subtitle2"
                        gutterBottom
                        color="secondary"
                        inline
                      >
                        * Required fields
                      </Typography>
                      <Typography variant="subtitle1" gutterBottom inline>
                        <b>)</b>
                      </Typography> */}
                    </div>

                    <Grid container className={classes.formArea}>
                      <Grid item xs={12} sm={6} className={classes.textFields}>
                        <TextField
                          required
                          margin="dense"
                          id="company"
                          name="company"
                          label={localizationManager.getLocalString(
                            "@@company_inqury"
                          )}
                          autoComplete="organization"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} className={classes.textFields}>
                        <TextField
                          required
                          margin="dense"
                          id="website"
                          name="website"
                          label={localizationManager.getLocalString(
                            "@@website"
                          )}
                          autoComplete="url"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          margin="dense"
                          id="name"
                          name="name"
                          label={localizationManager.getLocalString("@@name")}
                          autoComplete="given-name"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          margin="dense"
                          id="email"
                          name="email"
                          label={localizationManager.getLocalString("@@email")}
                          autoComplete="email"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          margin="dense"
                          id="tel"
                          name="tel"
                          label={localizationManager.getLocalString("@@tel")}
                          autoComplete="tel"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} className={classes.textFields}>
                        <TextField
                          required
                          margin="dense"
                          id="jobTitle"
                          name="jobTitle"
                          label={localizationManager.getLocalString(
                            "@@job_title"
                          )}
                          autoComplete="organization-title"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          margin="dense"
                          id="country"
                          name="country"
                          label={localizationManager.getLocalString(
                            "@@country"
                          )}
                          autoComplete="billing country"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          required
                          margin="dense"
                          id="address"
                          name="address"
                          label={localizationManager.getLocalString(
                            "@@address"
                          )}
                          fullWidth
                          autoComplete="billing address-line1"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          required
                          margin="dense"
                          id="how"
                          name="how"
                          label={localizationManager.getLocalString(
                            "@@how_find_linkchamp"
                          )}
                          fullWidth
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>

                    <div>
                      <Typography
                        variant="subtitle1"
                        component="h3"
                        gutterBottom
                      >
                        <b>{localizationManager.getLocalString("@@message")}</b>
                      </Typography>
                    </div>
                    <Grid container spacing={16} className={classes.formArea}>
                      <Grid item xs={12}>
                        <TextField
                          margin="dense"
                          id="message"
                          name="message"
                          label={localizationManager.getLocalString(
                            "@@anything_else"
                          )}
                          fullWidth
                          multiline
                          rows="5"
                          className={classes.textField}
                          variant="outlined"
                          onChange={this.handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>

                    <div className={classes.buttons}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleDialogOpen}
                      >
                        <DeleteSharpIcon className={classes.leftIcon} />
                        {localizationManager.getLocalString("@@discard")}
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        type="submit"
                        disabled={Object.keys(this.props.cart).length <= 0}
                      >
                        <SendIcon className={classes.leftIcon} />
                        {localizationManager.getLocalString("@@submit")}
                      </Button>
                    </div>
                  </Paper>
                </form>
                <Dialog
                  open={this.state.isDialogOpen}
                  onClose={this.handleDialogClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {localizationManager.getLocalString(
                      "@@discard_inquiry_confirm"
                    )}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      {localizationManager.getLocalString(
                        "@@discard_inquiry_warning"
                      )}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleDialogClose} color="default">
                      {localizationManager.getLocalString("@@return")}
                    </Button>
                    <Button
                      onClick={this.handleDialogConfirm}
                      color="secondary"
                      autoFocus
                    >
                      {localizationManager.getLocalString("@@discard")}
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
          </div>
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

export default withTheme(theme)(withStyles(styles)(Inquiry));
